//import { toastr, ToastrOptions} from "toastr";

import * as uiv from "uiv"

    /**
 * Basic command response
 * Maps to AH.ModelBuilder.Model.Commands.BasicCommandResponse
 */
    export interface IBasicCommandResponse {
        success: boolean;
        response: string;
    }


    /**
     * Client notification 
     */
    export class ClientNotification {
        message: string;
        ok: boolean;
        showBusy: boolean;
        showOkOrNotOk: boolean;

        constructor(message: string, ok: boolean, showBusy: boolean, showOkOrNotOk: boolean) {
            

this.message = message;
            this.ok = ok;
            this.showBusy = showBusy;
            this.showOkOrNotOk = showOkOrNotOk;
        }
    }

    // Client notifier
    export class ClientNotifier {

        static Default = new ClientNotifier();

        //private static defaultToastrOptions: ToastrOptions =
        //{
        //    positionClass: "toast-bottom-right",
        //    timeOut: 2000,
        //    closeButton: false
        //}

        //private  static busyToastrOptions: ToastrOptions = 
        //{
        //    positionClass: "toast-bottom-right",
        //    timeOut: 0,
        //        closeButton: false,
        //    allowHtml: true
        //}

        //private static errorToastrOptions: ToastrOptions =
        //{
        //    positionClass: "toast-bottom-right",
        //    timeOut: 0,
        //    closeButton: true
        //}

    /**
     * ClientNotifierInterface.notify
     * @param notification
     */
        notify(notification: ClientNotification): void
        {
            this.doShowNotification(notification);
        }

        showErrorResponse = (data: any) => {
            var message: string;

            var exMessage: string;
            if (data.response && data.reponse.responseJSON) {
                message = data.response.responseJSON.message;
                exMessage = data.response.responseJSON.ExceptionMessage;
            } else {
                message = "Error communicating with server";
                exMessage = data.statusText;
            }

            if (exMessage)
                message = message + ": " + exMessage;

            this.showNotification(message, false, false);
        }

        /**
         * Handles success or fail of responses (theoretically)
         */
        globalResponseHandler = (response: any) => {

            if (response.responseJSON) {
                const success = response.responseJSON.success;
                const message = response.responseJSON.response;

                // These could be nothing, in the case of a typeahead response for example
                // where we can't seem to set global=false for the ajax call
                if (success == null || message == null)
                    return;

               this.showNotification(message, success, false);
            } else {
                this.showErrorResponse(response as any);
            }

        }

         showCommandResponse = (response: IBasicCommandResponse) => {

                 this.showNotification(response.response, response.success, false);

         }

        // Private notification method
        private doShowNotification(notification: ClientNotification): string {
                        
             // Method using text at top
             // this.doShowTextNotification(notification);

            // Using toastr
            // return this.doShowToastrNotification(notification);

            // Using uiv
             return this.doShowUivNotification(notification);

        }

       
        // * Shows a toastr notification
        // */
        //doShowToastrNotification = (notification: ClientNotification): JQuery => {

        //    if (notification.showBusy) {
        //        // Show notification that doesn't go away

        //        // Note: busyToastrOptions has allowHtml = true, so we can pass html
        //        const html = `<p><i class="fa fa-cog fa-spin"></i> ${notification.message}</p>`;

        //        return toastr.info(html, "", ClientNotifier.busyToastrOptions);
        //    } else {
        //        // Default notification that does go away by self
        //        const status = notification.ok ? "success" : "warning";

        //        const options = notification.ok
        //            ? ClientNotifier.defaultToastrOptions
        //            : ClientNotifier.errorToastrOptions;


        //        return toastr[status](notification.message, "", options);
        //    }
        //}

        /**
 * Shows a uiv notification
 */
        doShowUivNotification = (notification: ClientNotification): string => {

            const type = notification.ok ? "success" : "warning";

            var lines = notification.message.split("\n");

            const brokenString = lines.join("<br>");


            if (notification.showBusy) {
                // Show notification that doesn't go away

                // Note: busyToastrOptions has allowHtml = true, so we can pass html
                const html = `<p><i class="fa fa-cog fa-spin"></i> ${brokenString}</p>`;

                //return toastr.info(html, "", ClientNotifier.busyToastrOptions);

                 uiv.Notification.notify({
                    type: type,
                    //title: "Notification",
                    content: html,
                    dismissible: true, // So we can hack to close it by pressing the close button
                    placement: "top-right",
                    duration: 0,
                    html: true
                });

//                 return html;

            } else {
                // Default notification that does go away by self
//                const status = notification.ok ? "success" : "warning";

                //const options = notification.ok
                //    ? ClientNotifier.defaultToastrOptions
                //    : ClientNotifier.errorToastrOptions;


                uiv.Notification.notify({
                    type: type,
                    //title: "Notification",
                    content: brokenString,
                    dismissible: true,
                    placement: "bottom-right",
                    duration: notification.ok? 3000: 0,
                    html: true
                });

//                return brokenString;


                //return toastr[status](notification.message, "", options);
            }

            return lines[0];
        }

        doShowTextNotification = (notification: ClientNotification) => {
            if (notification.ok)
                $("#notificationsDiv").css("color", "#2196f3");
            else
                $("#notificationsDiv").css("color", "lightcoral");

            var loaderHtml = notification.showBusy ? '<img src="/Content/ajax-loader.gif"> ' : "";

            // Add space between loader and message if needed
            //if (notification.showBusy)
            //  notification.message = "  " + notification.message;

            var glyphClass = notification.ok ? "glyphicon-thumbs-up" : "glyphicon-thumbs-down";
            var glyphHtml = notification.showBusy ? "  " : '<span class= "glyphicon ' + glyphClass + '" > </span>  ';

            if (!notification.showOkOrNotOk)
                glyphHtml = " ";

            $("#notificationsDiv").html(loaderHtml + "<em>" + glyphHtml + notification.message + "</em>");

            
        }

        /**
         * Shows a notification
         * @param message
         * @param ok
         * @param showBusy
         */
        showNotification = (message: string, ok: boolean, showBusy: boolean): string => {
            return this.doShowNotification(new ClientNotification(message, ok, showBusy, true));
        }

        showBusyNotification(message: string): string {
            this.doShowNotification(new ClientNotification(message, true, true, true));
            return message;
        }


        /**
         * Shows a notification
         * @param message
         * @param ok
         * @param showBusy
         */
        showNotificationObject(message: any, ok: boolean, showBusy: boolean): void {
            this.doShowNotification(new ClientNotification(message, ok, showBusy, true));


        }

        /**
         *  Shows a message and nothing else
         * @param message
         */
        showSimpleMessage(message: string): void {
            this.doShowNotification(new ClientNotification(message, true, false, false));

        }

        /**
         * Clears notifications (needed for busy notifications which don't go away)
         */
        clear(notification: JQuery | Promise<any>| string): void {


            if (typeof (notification) === "string") {

                //var searchString = notification.replace(/\\/g, "\\\\\\\\");
                var slashPos = notification.indexOf("\\");

                var searchString = slashPos > -1 ? notification.substr(0, slashPos - 1) :
                notification;

//                var paras = document.getElementsByTagName("p");
  //              for (var i = 0; paras.length

    //            forEach(var para )
//                var paras = $("p");

//                var containing = $. contains  contains(paras, searchString);

                var paras = $("p:contains(" + searchString + ")");

                var alerts = paras.closest('.alert');

                alerts.find('button')
                    .click();
            }
//                    .hide();


//            $('.alert').hide();

            //if (notification)


            //    toastr.clear(notification);
            //else
            //    // Clear all notifications
            //    toastr.clear();

        }
}





// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.client-notifications.ts